import { useNavigate } from "react-router-dom"
import axiosInstance from "../../services/axios-client"
import { useAuth } from "../../hooks/useAuth"
import { toast } from "react-toastify"

const useRedirectPageReset = () => {
   const {
      login
   } = useAuth()
   const navigate = useNavigate()

   const checkTokenAutoLogin = async (token) => {
      try {
         let res = await axiosInstance.post(`/autologin/${token}`)
         if (res.status === 200) {
            const { RequirePasswordReset, PasswordResetRedirectUrl } = res.data.data

            // Check if password reset is required
            if (RequirePasswordReset && PasswordResetRedirectUrl) {
               // Extract the path from the full URL
               const resetPath = PasswordResetRedirectUrl.split('/#')[1]
               // Redirect to reset page
               navigate(resetPath)
            } else {
               // No password reset required, redirect to login
               navigate('/login')
            }
         }
      } catch (error) {
         if (error.response) {
            toast.error(error?.response?.data?.status?.description || 'Authentication failed')
         } else if (error.message) {
            toast.error(error.message)
         } else {
            toast.error('An error occurred during authentication')
         }
         // Redirect to login page on error
         navigate('/login')
      }
   }

   // const checkTokenCalibrator = async (token, project_id, bu_performance, prev_calibrator, prev_calibrator_name) => {
   //    try {
   //       let res = await axiosInstance.post(`/autologin/${token}`)
   //       if (res.status === 200) {
   //          // console.log("DATA CALIBRATOR",token)
   //          login(res.data.data.AccessToken, JSON.stringify({
   //             ...res.data.data.TokenModel,
   //             SwitchUser: {
   //                Email: res.data.data.TokenModel.Email,
   //                ID: res.data.data.TokenModel.ID,
   //                Name: res.data.data.TokenModel.Name,
   //                Role: res.data.data.TokenModel.Role,
   //                Username: res.data.data.TokenModel.Username
   //             }
   //          }))
   //          if (bu_performance && prev_calibrator && prev_calibrator_name) {
   //             navigate(`/projects/${project_id}/${bu_performance}/${prev_calibrator}/${prev_calibrator_name}/default`)
   //          } else {
   //             navigate(`/home`)
   //          }
   //       }
   //    } catch (error) {
   //       if (error.response) {
   //          toast.error(error?.response?.data?.status?.description)
   //       } else if (error.message) {
   //          toast.error(error.message)
   //       } else {
   //          toast.error(error)
   //       }
   //    }
   // }

   // const checkTokenSpmo = async (token, project_id, calibrator_id, business_unit_id, phase) => {
   //    try {
   //       let res = await axiosInstance.post(`/autologin/${token}`)
   //       if (res.status === 200) {
   //          // console.log("DATA TOKEN SPMO",token)
   //          login(res.data.data.AccessToken, JSON.stringify({
   //             ...res.data.data.TokenModel,
   //             SwitchUser: {
   //                Email: res.data.data.TokenModel.Email,
   //                ID: res.data.data.TokenModel.ID,
   //                Name: res.data.data.TokenModel.Name,
   //                Role: res.data.data.TokenModel.Role,
   //                Username: res.data.data.TokenModel.Username
   //             }
   //          }))
   //          navigate(`/spmo-detail/${project_id}/${calibrator_id}/${business_unit_id}/${phase}`)
   //       }
   //    } catch (error) {
   //       if (error.response) {
   //          toast.error(error?.response?.data?.status?.description)
   //       } else if (error.message) {
   //          toast.error(error.message)
   //       } else {
   //          toast.error(error)
   //       }
   //    }
   // }

   return {
      checkTokenAutoLogin,
      // checkTokenCalibrator,
      // checkTokenSpmo,
   }
}

export default useRedirectPageReset